import { api } from '@/shared/utils/api';

export async function requestCode(email: string) {
  return await api({
    method: 'POST',
    url: '/auth/code',
    data: { email },
  });
}
